"use client";

import { getSupportedLocalesArray } from "@/config/locale.config";
import { LocaleToLabelMap, SupportedLocale } from "@/enums/locale.enum";
import { usePathname, useRouter } from "@/i18n/routing";
import Select from "@/ui/Common/Select";
import { HandleChangeValue } from "@/ui/Common/SelectList";
import { ensureTrailingSlash } from "@/utils/url";

export const LanguageChanger = ({
  locales: providedLocales,
  locale,
  arrowColor,
  type,
  isWhite,
}: {
  locales?: string[];
  locale: string;
  arrowColor: string;
  type?: "header_desktop" | undefined;
  isWhite?: boolean;
}) => {
  const router = useRouter();
  const currentPathname = usePathname();

  // Use provided locales or get from country config
  const supportedLocales = getSupportedLocalesArray();
  const locales =
    providedLocales || supportedLocales.map((locale) => locale.toString());

  const handleChange = (data: HandleChangeValue) => {
    const search = typeof window !== "undefined" ? window.location.search : "";
    const pathnameWithTrailingSlash = ensureTrailingSlash(currentPathname);

    router.push(`${pathnameWithTrailingSlash}${search}`, {
      locale: data.value,
    });
  };

  const newList = locales.map((el) => ({
    value: el,
    label:
      LocaleToLabelMap.get(el as SupportedLocale) || el?.toLocaleUpperCase(),
    isActive: el === locale,
  }));

  return (
    <Select
      type={type}
      current={
        LocaleToLabelMap.get(locale as SupportedLocale) || locale?.toUpperCase()
      }
      list={newList}
      handleChange={handleChange}
      arrowColor={arrowColor}
      isWhite={isWhite}
    />
  );
};
